import React, { useState } from 'react'
import PageInfoCard from '../../components/pageinfocard/PageInfoCard'
import PaymentDrawer from '../../components/paymentdrawer/PaymentDrawer'
import PaymentDataService from '../../../../services/PaymentDataService'
import { PLACE_OF_ORIGIN_FOR_PAYMENT } from '../../components/paymentdrawer/constants'
import { useDispatch } from 'react-redux'
import { getUserProfileAndPermissions } from '../../dashboard/DashboardSaga'

function PurchaseNoticePlan() {
  const [openNoticePaymentDrawer, setOpenNoticePaymentDrawer] = useState(false)
  const dispatch = useDispatch()
  return (
    <>
      <PageInfoCard
        cardTitle="You do not have the Notice Management add-on. Please click below to purchase the Add-on."
        confirmationButtonProps={{
          onConfirmationCb: () => { setOpenNoticePaymentDrawer(true) },
          confirmationButtonText: "Purchase Notice Mangement Add on",
        }} />

      <PaymentDrawer
        isOpen={openNoticePaymentDrawer}
        onCloseCb={() => {
          setOpenNoticePaymentDrawer(false)
        }}
        fees={{
          OnlySeparateStatefiling: "false",
          TotalFilingFee: 199,
          FilingFee: 199,
          USPSFee: "0",
          TINMatchFee: "0",
          StateFee: "0",
          TINCount: "0",
          StateFilingCount: "0",
          USPSCount: "0",
          FormCount: "0"
        }}
        filingFeeLabel="Notice Management Fee"
        paymentServiceFunctionCb={PaymentDataService.purchasePlan}
        calculatePrepaySalesTax={true}
      	paymentServiceFunctionExtraParams={{
            IsautorenewChecked:false,
            planPlanType: 3,
            IsNoticeChecked: true,
        }}
        calculateEstimatedTax={true}
        placeOfOriginforpayment={PLACE_OF_ORIGIN_FOR_PAYMENT.NOTICE_MANAGEMENT}
        onPaymentSuccessCb={() => {
          dispatch(getUserProfileAndPermissions())
        }}
      />
    </>
  )
}

export default PurchaseNoticePlan